{
  "id": "hyperion",
  "pantheon": "atlanteans",
  "name": {
    "pt-BR": "Hiperião",
    "en": "Hyperion"
  },
  "icon": "gods/hyperion",
  "portrait": "gods/hyperion-portrait",
  "age": "heroic",
  "freeUnitsOnAgeUp": {
    "satyr": 1
  },
  "unlocks": ["satyr", "pioneer-of-the-skies", "gemini", "heroic-renewal", "sons-of-the-sun"],
  "powers": ["chaos"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml HeroicAgeHyperion)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Age-up tech: CreateUnit 1 satyr at the Temple (Kronos: +1 from KronosExtra*, so 2). God power Chaos (cooldown 240 s)."
  }
}
